import { Box } from '@modusign/design-system';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import pictoWarning from '@app/assets/pictos/picto-warning.svg';
import { Modusign36h } from '@app/components/Logos';

interface NotFoundPageProps {
  title: string;
  children: ReactNode;
}

export default function NotFoundPage({ title, children }: NotFoundPageProps) {
  return (
    <div className="Background-Legacy Background--light-gray">
      <div className="Container Container--max-md">
        <div className="Card Card--theme-flat box-4x align-center">
          <Box textAlign="left">
            <Link style={{ display: 'inline-block' }} to="/">
              <Modusign36h style={{ cursor: 'pointer', marginBottom: 12 }} />
            </Link>
          </Box>
          <hr className="Line" />
          <img alt="주의" src={pictoWarning} />
          <h4>{title}</h4>
          <p>{children}</p>
          <Link className="align-left" to="/">
            <button className="Btn Btn--md" type="button">
              홈으로
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
